import React from 'react';

import HighlightColumn from '../Table/Decorator/HighlightColumn';
import Loading from '../../General/Loading';
import Table from '../Table/Table';
import { ExportPdf } from '../Pdf/ExportPdf';

import { MARKET_VALUE_FILTERS } from '../../../Constants/Interest/Filter';
import InterestUri from '../../../Enum/InterestUri';

import getHighlightedColumnNumber from '../../../Reducer/GetHighlightedColumnNumber';
import useGetInterestByMarketValue from '../../../Hook/Interest/FetchTableData/UseGetInterestByMarketValue';
import useIsFilterLoading from '../../../Hook/Interest/UseIsFilterLoading';
import useGetSort from '../../../Hook/Interest/UseGetSort';
import useGetFilteredValues from '../../../Hook/Interest/UseGetFilteredValues';

const InterestMarketValueTable: React.FC = () => {
    const currentSort = useGetSort(InterestUri.MarketValue);
    const { constructionType, energyLabel, fixedPeriod, loanForm, nhg, clientType, account } = useGetFilteredValues();
    const isFilterLoading = useIsFilterLoading();
    const { error, data, headers, loading } = useGetInterestByMarketValue(
        constructionType,
        energyLabel,
        loanForm,
        fixedPeriod,
        nhg,
        clientType,
        account,
    );

    if (isFilterLoading || loading) {
        return <Loading />;
    }

    if (error || !data.length || !headers.length) {
        return <p className="no-results">Geen resultaten gevonden, pas uw filters aan.</p>;
    }

    const highlightedColumnNO = getHighlightedColumnNumber(currentSort.prop, headers);
    return (
        <>
            {highlightedColumnNO > 0 && <HighlightColumn column={highlightedColumnNO} />}
            <ExportPdf
                filterSettings={MARKET_VALUE_FILTERS}
                headers={headers}
                rows={data}
                section={InterestUri.MarketValue}
                sort={currentSort}
            />
            <Table
                className="interest-market-value"
                data={data}
                headers={headers}
                section={InterestUri.MarketValue}
                sort={currentSort}
            />
        </>
    );
};

export default InterestMarketValueTable;
